'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarItem = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  overflow: hidden;\n  height: auto;\n  font-family: ', ';\n  font-size: ', ';\n'], ['\n  background-color: ', ';\n  overflow: hidden;\n  height: auto;\n  font-family: ', ';\n  font-size: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  input {\n    display: none;\n  }\n  label {\n    display: block;\n    padding: 10px;\n    background: ', ';\n    font-size: ', ';\n    cursor: pointer;\n    color: ', ';\n    border-bottom: ', ' solid\n      ', ';\n  }\n  label:hover {\n    background-color: ', ';\n  }\n  ul {\n    width: 100%;\n    list-style: none;\n    overflow: hidden;\n    max-height: 0;\n    transition: all .2s linear;\n  }\n  ul li a {\n    width: 100%;\n    height: 20px;\n    padding: 10px;\n    display: block;\n    text-decoration: none;\n    background-color: ', ';\n    color: ', ';\n    border-bottom: solid ', '\n      ', ';\n  }\n  ul li a:hover {\n    background-color: ', ';\n  }\n  input:checked ~ ul {\n    height: auto;\n    max-height: 200px;\n    transform: all;\n  }\n'], ['\n  input {\n    display: none;\n  }\n  label {\n    display: block;\n    padding: 10px;\n    background: ', ';\n    font-size: ', ';\n    cursor: pointer;\n    color: ', ';\n    border-bottom: ', ' solid\n      ', ';\n  }\n  label:hover {\n    background-color: ', ';\n  }\n  ul {\n    width: 100%;\n    list-style: none;\n    overflow: hidden;\n    max-height: 0;\n    transition: all .2s linear;\n  }\n  ul li a {\n    width: 100%;\n    height: 20px;\n    padding: 10px;\n    display: block;\n    text-decoration: none;\n    background-color: ', ';\n    color: ', ';\n    border-bottom: solid ', '\n      ', ';\n  }\n  ul li a:hover {\n    background-color: ', ';\n  }\n  input:checked ~ ul {\n    height: auto;\n    max-height: 200px;\n    transform: all;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Sidebar = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.bahSidebarBgColor;
}, function (props) {
  return props.theme.bahFontFamily;
}, function (props) {
  return props.theme.bahSidebarFonteSize;
});

var SidebarItem = exports.SidebarItem = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.theme.bahSidebarItemLabelBgColor;
}, function (props) {
  return props.theme.bahSidebarItemLabelFonteSize;
}, function (props) {
  return props.theme.bahSidebarItemLabelTextColor;
}, function (props) {
  return props.theme.bahSidebarItemLabelBorderSize;
}, function (props) {
  return props.theme.bahSidebarItemLabelBorderColor;
}, function (props) {
  return props.theme.bahSidebarItemLabelHoverBgColor;
}, function (props) {
  return props.theme.bahSidebarItemUlBgColor;
}, function (props) {
  return props.theme.bahSidebarItemUlTextColor;
}, function (props) {
  return props.theme.bahSidebarItemUlBorderSize;
}, function (props) {
  return props.theme.bahSidebarItemUlBorderColor;
}, function (props) {
  return props.theme.bahSidebarItemUlHoverBgColor;
});

exports.default = Sidebar;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/Sidebar.js
// module id = 107
// module chunks = 0